export default "__VITE_ASSET__DUPgoO5s__"